import React from 'react';
import { func, string, arrayOf } from 'prop-types';
import classNames from 'classnames';
import Question from '../Question';
import { QUICK_QUESTIONS_VIEW_IS_SHOWN } from '../../../constants/biEvents';
import { QuickQuestionViewType } from '../constants';
import { useEffectOnce, useReporting } from '../../../hooks';

const QuickQuestionsList = ({
    className,
    currentSteps,
    onStepClick
}) => {
    const { sendBiEvent, sendMixpanelEvent } = useReporting();

    useEffectOnce(() => {
        const params = {
            source: QuickQuestionViewType.LIST
        };

        const event = {
            type: QUICK_QUESTIONS_VIEW_IS_SHOWN,
            params
        };

        sendBiEvent(event);
        sendMixpanelEvent(event);
    });

    const wrapperClasses = classNames(
        'p-t-24',
        'flex',
        'flex-col',
        className
    );

    return (
        <section className={wrapperClasses}
            data-testid="quick-questions-list">
            {currentSteps.map((step) => (
                <Question key={step} step={step} onStepClick={onStepClick}/>
            ))}
        </section>
    );
};

QuickQuestionsList.propTypes = {
    className: string,
    currentSteps: arrayOf(string).isRequired,
    onStepClick: func
};

export default QuickQuestionsList;
